/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEventsResponse
 */
export interface BulkEventsResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkEventsResponse
     */
    ok: number;
    /**
     * 
     * @type {number}
     * @memberof BulkEventsResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BulkEventsResponse
     */
    failures: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkEventsResponse
     */
    failuresTruncated: boolean;
}

/**
 * Check if a given object implements the BulkEventsResponse interface.
 */
export function instanceOfBulkEventsResponse(value: object): value is BulkEventsResponse {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('failures' in value) || value['failures'] === undefined) return false;
    if ((!('failuresTruncated' in (value as Record<string, any>)) && !('failures_truncated' in (value as Record<string, any>))) || ((value as Record<string, any>)['failuresTruncated'] === undefined && (value as Record<string, any>)['failures_truncated'] === undefined)) return false;
    return true;
}

export function BulkEventsResponseFromJSON(json: any): BulkEventsResponse {
    return BulkEventsResponseFromJSONTyped(json, false);
}

export function BulkEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'failed': json['failed'],
        'failures': json['failures'],
        'failuresTruncated': json['failures_truncated'],
    };
}

export function BulkEventsResponseToJSON(json: any): BulkEventsResponse {
    return BulkEventsResponseToJSONTyped(json, false);
}

export function BulkEventsResponseToJSONTyped(value?: BulkEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
        'failed': value['failed'],
        'failures': value['failures'],
        'failures_truncated': value['failuresTruncated'],
    };
}

